(function () {
  'use strict';

  var cfg = window.FreeGiftConfig;
  if (!cfg || !cfg.defaultVariantId || !cfg.param) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var variantIds = (cfg.variantIds || []).map(Number);
  var busy = false;

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function renderTargets() {
    var t = [];
    if (document.getElementById('CartDrawer')) t.push({ elId: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
    if (document.getElementById('cart-icon-bubble')) t.push({ elId: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    if (document.getElementById('cart-live-region-text')) t.push({ elId: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' });
    var mci = document.getElementById('main-cart-items');
    if (mci) t.push({ elId: 'main-cart-items', section: mci.dataset.id, selector: '.js-contents' });
    var mcf = document.getElementById('main-cart-footer');
    if (mcf) t.push({ elId: 'main-cart-footer', section: mcf.dataset.id, selector: '.js-contents' });
    return t;
  }

  function inject(sections) {
    if (!sections) return;
    renderTargets().forEach(function (t) {
      var html = sections[t.section];
      if (!html) return;
      var source = new DOMParser().parseFromString(html, 'text/html').querySelector(t.selector);
      var host = document.getElementById(t.elId);
      if (!source || !host) return;
      var dest = host.querySelector(t.selector) || host;
      dest.innerHTML = source.innerHTML;
    });
  }

  function sectionParams() {
    var names = renderTargets().map(function (t) { return t.section; });
    return names.filter(function (v, i) { return names.indexOf(v) === i; });
  }

  function post(url, body) {
    body.sections = sectionParams();
    body.sections_url = window.location.pathname;
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function publishUpdate() {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' });
      }
    } catch (e) {}
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    var icon = document.querySelector('#cart-icon-bubble') || document.querySelector('a[href$="/cart"]');
    if (icon) icon.click();
  }

  function addGift() {
    return post('cart/add.js', { items: [{ id: cfg.defaultVariantId, quantity: 1 }] })
      .then(function (data) { inject(data && data.sections); publishUpdate(); openDrawer(); })
      .catch(function () {});
  }

  // Add the gift when the special link (?param) is visited.
  function handleLink() {
    var params = new URLSearchParams(window.location.search);
    if (!params.has(cfg.param)) return;
    // Clean the keyword out of the URL so a refresh doesn't re-add.
    params.delete(cfg.param);
    var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var has = cart.items.some(function (i) { return variantIds.indexOf(i.variant_id) !== -1; });
      if (has) { openDrawer(); return null; }
      return addGift();
    }).catch(function () {}).then(function () { busy = false; });
  }

  // Swap the gift's size from the cart line (removes old variant, adds chosen one).
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('.js-free-gift-size');
    if (!sel || busy) return;
    var newId = parseInt(sel.value, 10);
    var oldId = parseInt(sel.getAttribute('data-current'), 10);
    if (!newId || newId === oldId) return;
    busy = true;
    sel.disabled = true;
    var updates = {};
    updates[oldId] = 0;
    updates[newId] = 1;
    post('cart/update.js', { updates: updates })
      .then(function (data) { inject(data && data.sections); publishUpdate(); })
      .catch(function () {})
      .then(function () { busy = false; });
  });

  if (document.readyState !== 'loading') handleLink();
  else document.addEventListener('DOMContentLoaded', handleLink);
})();
